<template>
  <div class="error-page">
    <div class="inner-page">
      <img src="~/assets/img/common/game-bar.png" />
      <div class="title">哎吆，出错了</div>
      <div class="content">{{ content }}</div>
      <button class="btn" @click="refresh">刷新</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    content() {
      if (this.error.statusCode === 404) return '抱歉，您访问的页面不存在'
      return this.error.message || '出错啦~'
    }
  },
  mounted() {
    this.$sentry.error(this.error)
  },
  methods: {
    refresh() {
      location.reload()
    }
  }
}
</script>

<style lang="scss">
.error-page {
  height: calc(100vh - 156px);
  .inner-page {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
  }
  img {
    width: 58px;
    height: 70px;
  }
  .title {
    font-size: 18px;
    color: #00001d;
    margin-bottom: 11px;
  }
  .content {
    font-size: 12px;
    color: #7e8aa5;
  }
  .btn {
    width: 90px;
    height: 35px;
    font-size: 14px;
    color: #508aff;
    background-color: #d4e3fd;
    border-radius: 18px;
    border: none;
    margin-top: 50px;
    cursor: pointer;
  }
}
</style>
